import { formatLocationForFirestore } from './geoUtils';

const getComponentText = (component) => (
  component?.longText ||
  component?.long_name ||
  component?.shortText ||
  component?.short_name ||
  ''
);

export const parseAddressComponents = (components = []) => {
  const address = {
    city: '',
    state: '',
    street: '',
    neighbourhood: '',
    village: '',
    pincode: ''
  };

  components.forEach((component) => {
    const value = getComponentText(component);

    if (component.types?.includes('route')) address.street = value;
    if (component.types?.includes('locality')) address.city = value;
    if (component.types?.includes('administrative_area_level_1')) address.state = value;
    if (component.types?.includes('sublocality_level_1')) address.village = value;
    if (component.types?.includes('sublocality_level_2')) address.neighbourhood = value;
    if (component.types?.includes('postal_code')) address.pincode = value;
  });

  if (address.neighbourhood && !address.village) {
    address.village = address.neighbourhood;
  }

  return address;
};

const getLatLng = (location) => {
  if (!location) return null;

  const latitude = typeof location.lat === 'function' ? location.lat() : location.lat;
  const longitude = typeof location.lng === 'function' ? location.lng() : location.lng;

  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return null;
  }

  return { latitude, longitude };
};

export const buildLocationFromGooglePlace = (place) => {
  const location = getLatLng(place?.location || place?.geometry?.location);

  if (!location) {
    return null;
  }

  const address = parseAddressComponents(
    place?.addressComponents || place?.address_components || []
  );

  const finalLocation = formatLocationForFirestore(
    address,
    location.latitude,
    location.longitude
  );

  finalLocation.display =
    place?.formattedAddress ||
    place?.formatted_address ||
    place?.displayName ||
    '';

  return finalLocation;
};

